const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

const SCROLL_SYNERGY_CLASSNAME = 'scroll-synergy';
const SYNERGY_POSITION_CLASSNAME = 'synergy-position-';
const SCROLL_ZOOM_IN_CLASSNAME = 'synergy--zoom-in';
const SCROLL_PARALLAX_CLASSNAME = 'synergy--parallax';
const SCROLL_CRAB_LEFT_CLASSNAME = 'synergy--crab-left';
const SCROLL_CRAB_RIGHT_CLASSNAME = 'synergy--crab-right';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }

      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

/**
 * 初始化滚屏动画效果
 * @param {Document | HTMLElement} rootEl
 * @param {Boolean} isDesignModeEvent
 */
function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

/**
 * 协同页面滚动动画
 * 获取页面滚动比例，协同动画效果
 * 有放大，差动，横向移动效果
 */
function initializeScrollSynergy() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isMobileScreen()) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_SYNERGY_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const observer = new IntersectionObserver((elements) => {
    elements.forEach((entry) => {
      let prePosition;

      const handleScroll =  throttle(() => {
        const percentage = percentageSeen(entry.target);
        let position = 0;
        if(percentage <= 0) {
          position = 0;
        } else if(percentage < 30) {
          // 最佳展示位置
          position = 1
        } else if(percentage < 100) {
          position = 2
        } else {
          position = 3
        }

        if(prePosition !== position) {
          entry.target.classList.remove(`${SYNERGY_POSITION_CLASSNAME}-1`, `${SYNERGY_POSITION_CLASSNAME}-2`);

          if (position > 0 && position < 3) {
            entry.target.classList.add(`${SYNERGY_POSITION_CLASSNAME}-${position}`);
          }
          prePosition = position;
        }

        entry.target.style.setProperty('--synergy-ratio', `${percentage}%`);

        if(entry.target.classList.contains(SCROLL_ZOOM_IN_CLASSNAME)) {
          const zoomInRatio = 1 + 0.005 * percentage;
          entry.target.style.setProperty('--zoom-in-ratio', zoomInRatio.toString());
        } else if(entry.target.classList.contains(SCROLL_PARALLAX_CLASSNAME)) {
          const parallaxRatio = percentage / 100;
          entry.target.style.setProperty('--parallax-ratio', parallaxRatio.toString());
        } else if (entry.target.classList.contains(SCROLL_CRAB_LEFT_CLASSNAME) || entry.target.classList.contains(SCROLL_CRAB_RIGHT_CLASSNAME)) {
          let crabRatio = 0.25 * percentage;
          if(entry.target.classList.contains(SCROLL_CRAB_LEFT_CLASSNAME)) {
            crabRatio = -1 * crabRatio;
          }

          entry.target.style.setProperty('--crab-ratio', `${crabRatio}%`);
        }
      });

      if(entry.isIntersecting) {
        window.addEventListener('scroll', handleScroll);
      }else {
        window.removeEventListener('scroll', handleScroll);
      }
    });
  });

  animationTriggerElements.forEach(element => {
    observer.observe(element);
  });
}

/**
 * 获取元素在视窗内的移动比例
 * 刚进入:0; 完全离开是 100
 * @param element
 * @returns {string}
 */
function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return percentage.toFixed(2);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollSynergy();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
